import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import { IDeviceFormValues } from '../../../../@types/model/masterData/device/deviceFormValues';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';
import { yupResolver } from '@hookform/resolvers/yup';
import DeviceModelHelper from '../../../../@types/model/masterData/device/deviceModelHelper';

interface IDeviceFormProps {
    isLoading : boolean;
    initialValues : IDeviceFormValues;
    onSubmit : (values : IDeviceFormValues) => void;
    onClose : () => void;
}

const DeviceForm = (props : IDeviceFormProps) : React.ReactElement => {
    const { handleSubmit, control, formState: { isValid, isDirty }, trigger } = useForm<IDeviceFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(DeviceModelHelper.formSchema()),
        mode: 'onChange',
    });

    /*================================================================================================================
     *                                                  Queries
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    useEffect(() => {
        trigger();
    }, []);

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div>
            <CustomReactHookFormDevTools control={control} />
            <form onSubmit={handleSubmit(props.onSubmit)} className={'p20'}>
                <div className={'fdc'}>
                    <ControlledTextField
                        className={'mb10 w500'}
                        name={'name'}
                        label={'Name'}
                        control={control}
                        defaultValue={props.initialValues.name}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb10 w500'}
                        name={'serialNumber'}
                        label={'Serial Number'}
                        control={control}
                        defaultValue={props.initialValues.serialNumber}
                        size={'small'}
                    />
                    <div className={'fdr jcfs mb5'}>
                        <ControlledLabelledCheckBox
                            className={'p0'}
                            name={'isActive'}
                            label={'Is Active'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe'}>
                        <Button 
                            className={'cpd mr20'}
                            onClick={props.onClose} 
                            type={'reset'}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={ !isDirty || !isValid || props.isLoading }
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default DeviceForm;
